import React from "react";
import Logo from "./Logo";
import { Linkedin, Youtube, Instagram } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="section-dark border-t" style={{ borderColor: "rgba(250,250,247,0.12)" }} data-testid="footer">
      <div className="container-edge py-14 grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
        {/* Brand */}
        <div className="md:col-span-1">
          <Logo size={44} invert />
          <p
            className="mt-6 font-mono text-[11px]"
            style={{ color: "rgba(250,250,247,0.6)", letterSpacing: "0.14em" }}
          >
            LEARN. BUILD. HIRE. INVEST.
          </p>
          <p
            className="mt-4 font-display italic text-[18px] max-w-[360px]"
            style={{ color: "rgba(250,250,247,0.85)", fontWeight: 400 }}
          >
            From your first prompt to your first product to your first round.
          </p>
          <div className="mt-8 flex gap-4" data-testid="footer-socials">
            {[
              { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/aiforeveryone.ai/?hl=en" },
              { Icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@aiforeveryone-int" },
              { Icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/in/soumojitdasintime/" },
            ].map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 flex items-center justify-center border rounded-sm transition-colors hover:bg-[rgba(250,250,247,0.08)]"
                style={{ borderColor: "rgba(250,250,247,0.2)", color: "var(--canvas)" }}
                data-testid={`footer-social-${label.toLowerCase()}`}
              >
                <Icon size={16} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        {/* Navigate */}
        <div>
          <p className="mono-label-gold mb-5">NAVIGATE</p>
          <ul className="space-y-3">
            {[
              ["Learn (Certifications)", "#certifications"],
              ["Build (Innovation Arena)", "#arena"],
              ["Hire (AI Jobs · Talent Pipeline)", "#beyond-talent"],
              ["Invest (Pitch Hub)", "#beyond"],
              ["Adopt (AI Adoption Services)", "#adopt"],
              ["Manifesto", "#manifesto"],
              ["Press / Media kit", "mailto:ai@intimeinc.co.in?subject=Press%20enquiry"],
              ["Community", "#beyond"],
              ["Partners", "#partners"],
            ].map(([label, href]) => (
              <li key={label}>
                <a
                  href={href}
                  className="text-[14px] link-underline"
                  style={{ color: "rgba(250,250,247,0.78)" }}
                  data-testid={`footer-nav-${label.split(" ")[0].toLowerCase()}`}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <p className="mono-label-gold mb-5">CONTACT</p>
          <ul className="space-y-3 text-[14px]" style={{ color: "rgba(250,250,247,0.78)" }}>
            <li>
              <span className="font-mono text-[11px] block" style={{ color: "rgba(250,250,247,0.5)", letterSpacing: "0.12em" }}>
                EMAIL
              </span>
              <a href="mailto:ai@intimeinc.co.in" className="link-underline" data-testid="footer-email">
                ai@intimeinc.co.in
              </a>
            </li>
            <li>
              <span className="font-mono text-[11px] block" style={{ color: "rgba(250,250,247,0.5)", letterSpacing: "0.12em" }}>
                CALL US
              </span>
              <a href="tel:+919051615690" className="link-underline" data-testid="footer-phone">
                +91 90516 15690
              </a>
            </li>
            <li>
              <span className="font-mono text-[11px] block" style={{ color: "rgba(250,250,247,0.5)", letterSpacing: "0.12em" }}>
                WHATSAPP
              </span>
              <a
                href="https://wa.me/919051615690"
                target="_blank"
                rel="noreferrer"
                className="link-underline"
                data-testid="footer-whatsapp"
              >
                Message us →
              </a>
            </li>
            <li>
              <span className="font-mono text-[11px] block" style={{ color: "rgba(250,250,247,0.5)", letterSpacing: "0.12em" }}>
                OFFICE
              </span>
              Kolkata, India
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        className="border-t font-mono text-[11px]"
        style={{ borderColor: "rgba(250,250,247,0.12)", color: "rgba(250,250,247,0.55)", letterSpacing: "0.06em" }}
      >
        <div className="container-edge py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p data-testid="footer-copyright">
            © {year} AI For Everyone. Powered by InTime IT Services Pvt. Ltd.
          </p>
          <p>
            The Practitioner Method™ and the AI+ certification family are proprietary marks of InTime IT Services Pvt. Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
}
